import React from "react";
import {calculateNumberToDay} from "../Compare";
import {CompareMonthCells} from "./CompareMonthCells";
import {STICKY_TH} from "./slaCompareStickyClasses";
import "../slaCompare.css";

function CompareItem({data, dateList}){
    return(
        <>
            {/*장애건수*/}
            <tr>
                <th className={STICKY_TH.c1} rowSpan={14}>장애관리</th>
                <th className={STICKY_TH.c2_3} rowSpan={5} colSpan={2}>장애건수</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[0].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>서비스장애</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[0].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>일반장애</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[0].countTwo}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[0].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[0].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>







            {/*장애 복구율*/}
            <tr>
                <th className={STICKY_TH.c2_3} rowSpan={5} colSpan={2}>장애 복구율</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[1].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>장애건수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[1].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>복구시간 초과건수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[1].countTwo}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[1].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[1].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>



            {/*동일장애 발생건수*/}
            <tr>
                <th className={STICKY_TH.c2_3} rowSpan={4} colSpan={2}>동일장애 발생건수</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[2].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>동일장애건수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[2].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[2].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[2].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>







            <tr>
                <th className={STICKY_TH.c1} rowSpan={37}>관리 서비스</th>
                <th className={STICKY_TH.c2} rowSpan={5}>보고</th>
                <th className={STICKY_TH.c3} rowSpan={5}>적기보고 실시율</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[3].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>장애 및 이슈 발생건수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[3].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>적기보고건수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[3].countTwo}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[3].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[3].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>

            <tr>
                <th className={STICKY_TH.c2} rowSpan={5}>관리</th>
                <th className={STICKY_TH.c3} rowSpan={5}>산출물 납기준수율</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[4].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>전체 산출물 수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[4].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>제출일정 초과</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[4].countTwo}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[4].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[4].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>


            <tr>
                <th className={STICKY_TH.c2_3} rowSpan={6} colSpan={2}>서비스요청 적기처리율</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[5].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>서비스 완료건수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[5].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>적기 완료 서비스</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[5].countTwo}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>총 지연시간</th>
                {
                    <CompareMonthCells>
                        {(raw) => calculateNumberToDay(raw.item[5].timeOne)}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[5].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[5].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>

            <tr>
                <th className={STICKY_TH.c2_3} rowSpan={6} colSpan={2}>작업 적기처리율</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[6].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>총 완료 작업건수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[6].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>적기 완료 작업</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[6].countTwo}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>총 지연시간</th>
                {
                    <CompareMonthCells>
                        {(raw) => calculateNumberToDay(raw.item[6].timeOne)}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[6].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[6].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>

            <tr>
                <th className={STICKY_TH.c2_3} rowSpan={6} colSpan={2}>점검 적기처리율</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[7].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>총 완료 점검건수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[7].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>적기 완료 점검</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[7].countTwo}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>총 지연시간</th>
                {
                    <CompareMonthCells>
                        {(raw) => calculateNumberToDay(raw.item[7].timeOne)}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[7].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[7].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>

            <tr>
                <th className={STICKY_TH.c2_3} rowSpan={4} colSpan={2}>성능개선 제안</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[8].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>성능개선 제안건수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[8].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[8].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[8].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>

            <tr>
                <th className={STICKY_TH.c2_3} rowSpan={5} colSpan={2}>내부자료 유출 및 중요 데이터 손실</th>
                <th className={STICKY_TH.c4}>가중치</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[9].weight + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>내부자료 유출횟수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[9].countOne}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>데이터 소실횟수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[9].countTwo}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>평가점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[9].evaluationScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>
            <tr>
                <th className={STICKY_TH.c4}>환산점수</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.item[9].convertedScore + ' %'}
                    </CompareMonthCells>
                }
            </tr>

            <tr>
                <th colSpan={3} className={STICKY_TH.c1_3}>합계</th>
                <th className={STICKY_TH.c4}>평가결과</th>
                {
                    <CompareMonthCells>
                        {(raw) => raw.evaluationResult + ' %'}
                    </CompareMonthCells>
                }
            </tr>
</>
    )
}

export {CompareItem}